module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0745-min.84f8a604.jpg";